<script setup lang="ts">
import i18n from '@/lang/i18n';
</script>

<template>
  <tr class="table-header">
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.restraintTimeByDay') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.restraintDays') }}
    </td>
  </tr>
  <tr class="table-header">
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.averageGoal') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.actualAssumption') }}
    </td>
  </tr>
</template>

<style scoped>
.summary-times-container td {
  padding: 7px;
  text-align: center;
  font-weight: bold !important;
  border: 1 !important;
  border-width: 2px !important;
}
.summary-times-container .table-header {
  background-color: silver !important;
}
.summary-times-container tr {
  line-height: 15px;
  font-size: 13px;
}
</style>
